import { v4 as uuidv4 } from 'uuid';

export const ADD_SNACKBAR_MESSAGE = 'SNACKBAR/ADD_MESSAGE';
export const REMOVE_SNACKBAR_MESSAGE = 'SNACKBAR/REMOVE_MESSAGE';

// valid types are 'info' | 'error' | 'warning' | 'default' | 'success'
export function addMessage(message = '', type = 'default', autoClose = 6500) {
  return {
    type: ADD_SNACKBAR_MESSAGE,
    response: {
      message: { id: uuidv4(), message, type, autoClose },
    },
  };
}

export function removeMessage(id: any) {
  return {
    type: REMOVE_SNACKBAR_MESSAGE,
    response: { id },
  };
}
